























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Page } from '@/core/components/controls';
import { TableOptions, getTableCaption } from '@/core/components/table';
import ReplacementsTable from './ReplacementsTable.vue';
import { ReplacementsPageArgs } from './types';

@Component({
    components: {
        ReplacementsTable,
        TableOptions,
    },
})
export default class ReplacementsPage extends Page {
    @Prop({ default: () => ({}) }) public args!: ReplacementsPageArgs;

    public table: any = null;
    public processing: boolean = false;

    public async mounted() {
        this.table = this.getTable().getDataGridInstance();
    }

    public get tableKey(): string {
        return 'replacements-control';
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public getTable(): ReplacementsTable {
        const element = this.$refs['table-control'] as unknown;
        return element as ReplacementsTable;
    }

    public setProcessing(isProcessing: boolean) {
        this.processing = isProcessing;
    }
}
